export const enums = {
  LITER: "liter",
  KG: "kg",
  CM: "cm",
};

export const mapping = {
  [enums.LITER]: "Литр",
  [enums.KG]: "Кг",
  [enums.CM]: "См",
};

export const mappingShort = {
  [enums.LITER]: "л",
  [enums.KG]: "кг",
  [enums.CM]: "см",
};
